module.exports = __webpack_public_path__ + "img/icon-back.8e285024.svg";